import script from "./RPTaxBillsViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./RPTaxBillsViewer.vue?vue&type=script&setup=true&lang=js"

import "./RPTaxBillsViewer.vue?vue&type=style&index=0&id=5d6da916&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d6da916"]])

export default __exports__